import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ServicesReceived5 from "../Forms/K/ServicesReceived/ServicesReceived5"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ServicesReceived5Container = ({
  showToolBar,
  disabled,
  interview_id,
}) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)
  const [isGettingServicesReceived, setIsGettingServicesReceived] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingServicesReceived(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_SERVICESRECEIVED_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SERVICES_RECEIVED_5,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SERVICES_RECEIVED_5
          )
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingServicesReceived(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const setValues = (data) => {
    return {
      gpra_k_2: data?.form?.gpraK2,
      gpra_k_3: data?.form?.gpraK3,
      gpra_k_4: data?.form?.gpraK4,
      gpra_k_4a1: data?.form?.gpraK4a1 ?? 0,
      gpra_k_4a2: data?.form?.gpraK4a2 ?? 0,
      gpra_k_4a3: data?.form?.gpraK4a3 ?? 0,
      gpra_k_4a4: data?.form?.gpraK4a4 ?? 0,
      gpra_k_4a5: data?.form?.gpraK4a5 ?? false,
      gpra_k_4b: data?.form?.gpraK4b ?? false,
      gpra_k_5: data?.form?.gpraK5,
      gpra_k_5a1: data?.form?.gpraK5a1 ?? 0,
      gpra_k_5a2: data?.form?.gpraK5a2 ?? 0,
      gpra_k_5a3: data?.form?.gpraK5a3 ?? 0,
      gpra_k_5a4: data?.form?.gpraK5a4 ?? 0,
      gpra_k_5a5: data?.form?.gpraK5a5 ?? false,
      gpra_k_5b: data?.form?.gpraK5b ?? false,
      gpra_k_6: data?.form?.gpraK6,
      gpra_k_6a1: data?.form?.gpraK6a1 ?? 0,
      gpra_k_6a2: data?.form?.gpraK6a2 ?? 0,
      gpra_k_6a3: data?.form?.gpraK6a3 ?? 0,
      gpra_k_6a4: data?.form?.gpraK6a4 ?? 0,
      gpra_k_6a5: data?.form?.gpraK6a5 ?? false,
      gpra_k_6b: data?.form?.gpraK6b ?? false,
      gpra_k_7: data?.form?.gpraK7,
      gpra_k_7a1: data?.form?.gpraK7a1 ?? 0,
      gpra_k_7a2: data?.form?.gpraK7a2 ?? 0,
      gpra_k_7a3: data?.form?.gpraK7a3 ?? 0,
      gpra_k_7a4: data?.form?.gpraK7a4 ?? false,
      gpra_k_7b: data?.form?.gpraK7b ?? false,
      gpra_k_id: data?.form?.gpraKId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingServicesReceived) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingServicesReceived && (
        <ServicesReceived5 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ServicesReceived5Container
